import { Component, OnInit, Input, QueryList, ViewChildren } from '@angular/core';
import { FormGroup, FormArray, FormControl } from '@angular/forms';
import { PlantingInstructionsFormComponent, PlantingInstructionCopyArgs } from './planting-instructions-form/planting-instructions-form.component';

@Component({
  selector: 'app-planting-instructions',
  templateUrl: './planting-instructions.component.html'
})
export class PlantingInstructionsComponent implements OnInit {
  @Input() public experimentDesignFormGroup: FormGroup;
  @Input() public isWheatRequest: boolean;

  public get treatments(): FormArray {
    return <FormArray>this.experimentDesignFormGroup.get('treatments');
  }

  public get numberOfSeedsPerCell(): FormControl {
    return this.experimentDesignFormGroup.get('numberOfSeedsPerCell') as FormControl;
  }

  public get numberToPotsEnabled(): boolean {
    return this.treatments.controls[0].get('plantingInstructions.numberToPots').enabled;
  }

  public get numberToHarvestEnabled(): boolean {
    return this.treatments.controls[0].get('plantingInstructions.numberToHarvest').enabled;
  }

  @ViewChildren(PlantingInstructionsFormComponent) 
  public plantingInstructionForms: QueryList<PlantingInstructionsFormComponent>;

  constructor() {
  }

  ngOnInit() {
  }

  public applyAll(sourceComponent: PlantingInstructionsFormComponent): void {
    const args: PlantingInstructionCopyArgs = {
      numberToHarvest: sourceComponent.numberToHarvest,
      numberToPots: sourceComponent.numberToPots
    };
    
    this.plantingInstructionForms.forEach(f => f.copyValueFrom(args));
  }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/planting-instructions/planting-instructions.component.ts